import {
  Header1,
  Instruction,
  InstructionWithContent,
} from "../../BlockComponent";
import { ButtonGroup, GuideTypographyLine } from "../../CellComponent";
import { LastCard } from "../common";

export const Content_13_2_A = [
  Header1("typography_0"),
  Instruction("typography_1"),
  Instruction("typography_2"),

  InstructionWithContent(`typography_3`, [
    [
      ButtonGroup(
        [
          { text: "A. 머릿속을 스치는 부정적인 '생각'" },
          { text: "B. 가슴이 답답해지는 '신체 반응'" },
          { text: "C. 부정적인 반응을 일으킨 객관적인 '상황'" },
          { text: "D. 당장이라도 도망치고 싶어지는 '충동'" },
        ],
        { id: "quiz1", vertical: true }
      ),
    ],
    GuideTypographyLine("typography_quiz_incorrect", {
      answerList: [{ id: "quiz1", answerIndex: 2 }],
    }),
  ]),
  Instruction("typography_4"),

  Header1("typography_5"),
  Instruction("typography_6"),
  Instruction("typography_7"),

  InstructionWithContent(`typography_8`, [
    [
      ButtonGroup(
        [
          { text: "A. 팀장님이 나를 귀찮아하며 회의를 서둘러 끝냈다." },
          { text: "B. 이번 주 내내 업무가 너무 많아서 매일 야근을 했다." },
          {
            text: "C. 오후 3시 회의에서 동료가 약속 시간보다 20분 늦게 도착했다.",
          },
        ],
        { id: "quiz2", vertical: true }
      ),
    ],
    GuideTypographyLine("typography_quiz_incorrect", {
      answerList: [{ id: "quiz2", answerIndex: 2 }],
    }),
  ]),
  Instruction("typography_9"),

  Header1("typography_10"),
  Instruction("typography_11"),
  Instruction("typography_12"),

  InstructionWithContent(`typography_13`, [
    [
      ButtonGroup(
        [
          {
            text: "A. 차가 막혀서 어쩔 수 없었는데 내가 너무 예민하게 굴었네.",
          },
          { text: "B. 나를 만만하게 봐서 이렇게 매번 늦는 게 틀림없어." },
          { text: "C. 그 친구가 저를 무시한다고 생각해서 기분이 나빴습니다." },
        ],
        { id: "quiz3", vertical: true }
      ),
    ],
    GuideTypographyLine("typography_quiz_incorrect", {
      answerList: [{ id: "quiz3", answerIndex: 1 }],
    }),
  ]),
  Instruction("typography_14"),

  Header1("typography_15"),
  Instruction("typography_16"),
  Instruction("typography_17"),

  InstructionWithContent(`typography_18`, [
    [
      ButtonGroup(
        [
          { text: "A. 이번 시험은 완전히 망쳐서 불안하고 답답하다." },
          { text: "B. 당장이라도 시험지를 찢어버리고 밖으로 도망치고 싶음" },
          { text: "C. 호흡이 가빠지고 손바닥에 식은땀이 남" },
        ],
        { id: "quiz4", vertical: true }
      ),
    ],
    GuideTypographyLine("typography_quiz_incorrect", {
      answerList: [{ id: "quiz4", answerIndex: 2 }],
    }),
  ]),
  Instruction("typography_19"),

  Header1("typography_20"),
  Instruction("typography_21"),
  Instruction("typography_22"),

  InstructionWithContent(`typography_23`, [
    [
      ButtonGroup(
        [
          {
            text: "A. 얼굴이 붉게 달아오르고 손이 심하게 떨려서 침대에 누워버림",
          },
          {
            text: "B. 분노가 치밀어 올랐지만, 마음을 다스리기 위해 눈을 감고 명상을 함",
          },
          {
            text: "C. 겉으로는 가만히 있었지만, 속으로는 상대방에게 소리를 지르고 싶었음",
          },
        ],
        { id: "quiz5", vertical: true }
      ),
    ],
    GuideTypographyLine("typography_quiz_incorrect", {
      answerList: [{ id: "quiz5", answerIndex: 2 }],
    }),
  ]),
  Instruction("typography_24"),

  Header1("typography_25"),
  Instruction("typography_26"),
  Instruction("typography_27"),
  Instruction("typography_28"),
  Instruction("typography_29"),

  ...LastCard,
];
